import React from "react";
import HeaderSlideshowStyles from "./Header-Slideshow.module.css";
import SlideshowCrossfade from "services/Slideshow-crossfade/Slideshow-crossfade";
import bioImage from "../../../assets/desktop/header/icon-1.png";
import teachImage from "../../../assets/desktop/header/icon-2.png";
import servicesImage from "../../../assets/desktop/header/icon-3.png";
import HeaderStyles from "../HeaderNew2026.module.css";
import { Image } from "react-bootstrap";

const HeaderSlideshow = () => {
  const slideshow = HeaderSlideshowStyles.slideshow;

  const {
    modernCardMobile,
    modernIconMobile,
    modernContainer,
    modernTitle,
    modernTextMObile,
    modernContainerMobile,
    sloganMobile,
  } = HeaderStyles;

  return (
    <SlideshowCrossfade className={slideshow}>
      {/* <div>
        <p className={mainTitle}>YOUR ONE STOP SHOP FOR:</p>
        <p className={subTitle}>Biologic Coordinator Services </p>
        <Image
          className={headerImg}
          src={bioImage}
          alt={"biologic-coordinator-icon"}
        />
        <p className={contentParagraph}>
          Managing prior authorizations, appeals, and patient communication to
          ensure seamless access to medications.
        </p>
      </div>
      <div>
        <p className={mainTitle}>YOUR ONE STOP SHOP FOR:</p>
        <p className={subTitle}>Office Education </p>
        <Image
          className={headerImg}
          src={teachImage}
          alt={"office-training-icon"}
        />
        <p className={contentParagraph}>
          Customized in-office training to improve medication management,
          enhance staff proficiency, and streamline patient care
        </p>
      </div>
      <div>
        <p className={mainTitle}>YOUR ONE STOP SHOP FOR:</p>
        <p className={subTitle}>Support and Resources </p>
        <Image
          className={headerImg}
          src={servicesImage}
          alt={"support-resources-icon"}
        />
        <p className={contentParagraph}>
          Access to up-to-date information, tools, and templates to assist with
          documentation and staying informed on industry developments.
        </p>
      </div> */}

      <div className={modernCardMobile}>
        <div>
          <Image
            className={modernIconMobile}
            src={bioImage}
            alt="Biologic Coordinator"
          />
        </div>
        <div className={modernContainerMobile}>
          <p className={modernTitle}>Biologic Coordination</p>
          <p className={sloganMobile}>
            <b>
              DESIGNED WITH <br />
              SPECIALTY MEDS IN MIND
            </b>
          </p>
          <p className={modernTextMObile}>
            • Prior authorizations, patient access, and biologic support
            <br />• Office training, resources, and workflow guidance
          </p>
        </div>
      </div>

      <div className={modernCardMobile}>
        <div>
          <Image
            className={modernIconMobile}
            src={teachImage}
            alt="Office Training"
          />
        </div>

        <div className={modernContainerMobile}>
          <p className={modernTitle}>Office Education</p>
          <p className={modernTextMObile}>
            • Hands-on biologic workflow training for specialty practices
            <br />• Improving office efficiency, communication, and patient care
          </p>
        </div>
      </div>

      <div className={modernCardMobile}>
        <div>
          <Image
            className={modernIconMobile}
            src={servicesImage}
            alt="Support Resources"
          />
        </div>

        <div className={modernContainerMobile}>
          <p className={modernTitle}>Resources & Support</p>
          <p className={modernTextMObile}>
            • Helpful tools, templates, and biologic coordination resources
            <br />• Industry guidance and ongoing office support
          </p>
        </div>
      </div>
    </SlideshowCrossfade>
  );
};

export default HeaderSlideshow;
